import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import { fadeInUp, textVariants } from '../../utility/framerAnimations';

const HeroSection = () => {
  return (
    <section className="emi-hero-section">
      <Container >
        <Row className="justify-content-center">
          <Col lg={10} md={12} sm={12}>
            <motion.div 
              className="hero-container"
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <motion.div 
                className="hero-title-container"
                variants={textVariants}
              >
               
                <motion.h1 
                  className="hero-title"
                  variants={textVariants}
                >
                  <motion.img 
                  src="/images/commercial-vehicle-emi.png" 
                  alt="Chart Icon" 
                  className="hero-icon"
                  variants={textVariants}
                /> Plan Smartly with Our EMI Calculator
                </motion.h1>
              </motion.div>
              
              <motion.p 
                className="hero-description"
                variants={textVariants}
              >
                Calculate your monthly loan installments quickly and easily to make informed financial decisions.
              </motion.p>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
